import styled from 'styled-components';

export const StyledIFrame = styled.iframe<{ src: string; title: string }>`
  border: none;
  border-radius: 8px;

  @media ${({ theme }) => theme.media.tablet} {
    height: 500px;
  }
`;
